<template>
<div class="row align-items-end h-100">
    <div class="col-12 align-self-end">
        <div class="row m-1 py-4 fw-bold">
            <div class="col-12 d-flex justify-content-center">
                <div class="h3 text-center"> {{thankYou}} </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 d-flex justify-content-center">
                <div class="p-5 text-center">
                    <img class="card-img-left img-responsive p-md-15" style="width: 100%;" src="assets/img/logo.png" alt="Image" /></div>
            </div>

        </div>
        <div class="row py-2">
            <div class="col-12 d-flex justify-content-center"> <button @click="gotoLanguages()" type="button" class="btn btn-viskase-orange m-5">
                    <i class="bi-play" role="img" aria-label="Play"></i> {{getStartedAgain}}
                </button></div>

        </div>
    </div>
    <div class="col-12">
        <img class="card-img-left img-responsive" style="width: 100%;" src="assets/img/thank-you-page.png" alt="Logo" />
    </div>
</div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import ViskaseCard from "@/components/core/ViskaseCard.vue";
import ViskaseTile from "@/components/core/ViskaseTile.vue";

export default {
  name: "ThankYou",
  components: {
    ViskaseCard,
    ViskaseTile,
  },
  mounted() {},

  data() {
    return {};
  },

  methods: {
    ...mapActions([]),
    ...mapMutations([]),
    gotoLanguages() {
      this.$router.push({
        name: "languages",
        params: {},
      });
    },
  },
  computed: {
    ...mapState(["cards"]),
    thankYou() {
      return this.cards.thankYou.thank_you;
    },
    getStartedAgain() {
      return this.cards.thankYou.get_started_again;
    },
    title() {
      return "";
    },
  },
};
</script> 

<style scoped>
@media (min-width: 768px) {
  .p-md-15 {
    padding-left: 15rem !important;
    padding-right: 15rem !important;
  }
}
</style>
